// Account, session and workspace settings.

import { useFrontDesk, useMe } from "@/api/hooks";
import { formatDateTime } from "@/lib/format";
import { ROLE_LABELS } from "@/lib/labels";
import { Details, PageHeader, Section } from "@/ui/layout";
import { useTitle, useRouteParams } from "../common/page";
import { CompanySection } from "../commercial/company-section";

export function SettingsPage() {
  const { orgId } = useRouteParams("orgId");
  const { data: me } = useMe();
  const { data: fd } = useFrontDesk(orgId);
  useTitle("Configuración");
  return (
    <div className="grid gap-8">
      <PageHeader title="Configuración" />
      <Section
        title="Tu cuenta"
        description="Tu acceso lo gestiona el proveedor de identidad; InteractAds no guarda contraseñas."
      >
        <Details
          items={[
            { label: "Nombre", value: me?.user.displayName ?? "—" },
            { label: "Correo", value: me?.user.email ?? "—" },
            {
              label: "Verificación adicional",
              value: me?.session.assuranceLevel === 2 ? "Confirmada en esta sesión" : "No confirmada en esta sesión",
            },
            { label: "Sesión vence", value: formatDateTime(me?.session.expiresAt) },
          ]}
        />
      </Section>
      <CompanySection orgId={orgId} />
      <Section title="Espacio de trabajo">
        <Details
          items={[
            { label: "Nombre", value: fd?.organization.name ?? "—" },
            { label: "Tu rol", value: fd ? ROLE_LABELS[fd.membership.role] : "—" },
          ]}
        />
      </Section>
      <Section title="Sesiones">
        <p className="text-sm text-muted">Para cerrar sesión en todos tus dispositivos, usa el menú de tu usuario.</p>
      </Section>
    </div>
  );
}
